module.exports = __webpack_public_path__ + "static/media/refresh.05d0d30f.svg";